import type { AxiosInstance } from 'axios'
import { getListHospitalsPaths } from './openapiPaths'
import { getWithPathFallback } from './httpHelpers'

export interface Hospital {
  id: string
  name: string
}

export async function fetchHospitals(
  client: AxiosInstance,
  params?: { sessionId?: string },
): Promise<Hospital[]> {
  const [primaryBase, alternateBase] = getListHospitalsPaths()

  let primary = primaryBase
  let alternate = alternateBase
  if (params?.sessionId) {
    const qs = `session_id=${encodeURIComponent(params.sessionId)}`
    primary = `${primaryBase}?${qs}`
    alternate = `${alternateBase}?${qs}`
  }

  const data = (await getWithPathFallback(client, primary, alternate)) as Record<
    string,
    string
  >

  return Object.entries(data)
    .filter(([id, name]) => Boolean(id) && Boolean(name))
    .map(([id, name]) => ({ id, name }))
}
